export default "__VITE_ASSET__C8ll8pkd__"